import { createAsyncThunk } from '@reduxjs/toolkit';

function getAccountIntegrations(_, { extra: { http } }) {
  return http.get(`/account_integrations`);
}
function getAccountIntegrationsNew({ integration_type }, { extra: { http } }) {
  // no need to hit API for now, just mock response on client-side
  return Promise.resolve({
    data: { account_integration: { integration_type } },
  });
}
function postAccountIntegrations({ account_integration }, { extra: { http } }) {
  return http.post(`/account_integrations`, { account_integration });
}
function getAccountIntegrationEdit({ id }, { extra: { http } }) {
  return http.get(`/account_integrations/${id}/edit`);
}
function deleteAccountIntegration({ id }, { extra: { http } }) {
  return http.delete(`/account_integrations/${id}`);
}
function patchAccountIntegration(
  { id, account_integration },
  { extra: { http } }
) {
  return http.patch(`/account_integrations/${id}`, { account_integration });
}

export const indexAccountIntegrations = createAsyncThunk(
  'account_integrations/index',
  getAccountIntegrations
);
export const newAccountIntegration = createAsyncThunk(
  'account_integrations/new',
  getAccountIntegrationsNew
);
export const createAccountIntegration = createAsyncThunk(
  'account_integrations/create',
  postAccountIntegrations
);
export const editAccountIntegration = createAsyncThunk(
  'account_integrations/edit',
  getAccountIntegrationEdit
);
export const updateAccountIntegration = createAsyncThunk(
  'account_integrations/update',
  patchAccountIntegration
);
export const removeAccountIntegration = createAsyncThunk(
  'account_integrations/delete',
  deleteAccountIntegration
);
